import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';
import { getInitRegistryInfo } from '../../features/Tournament/Registry/Const';

const debugStatus = {
  getRegistry: false,
  initRegistry: false,
  updateBasic: false,
  updateRegulationFile: false,
  updateRequirement: false,
  uploadDocument: false,
  removeDocument: false,
  updateFee: false,
  getReviewTeams: false,
  updateReviewTeamStatus: false,
  importReviewTeamToTournament: false,
};

const SeasonRegistry = {
  getRegistry: ({ seasonUniqid }) => {
    if (debugStatus.getRegistry) {
      return fakeApiHelper(200, 'success', {
        data: getInitRegistryInfo(),
        error: false,
        message: 'Get season registry successfully',
      });
    }

    return ApiService.get(`/api/seasons/${seasonUniqid}/registry`);
  },

  initRegistry: ({ seasonUniqid }) => {
    if (debugStatus.initRegistry) {
      return fakeApiHelper(200, 'success', {
        data: getInitRegistryInfo(),
        error: false,
        message: 'Init registry info successfully',
      });
    }

    return ApiService.post(`/api/seasons/${seasonUniqid}/registry`, { data: getInitRegistryInfo() });
  },

  updateBasic: ({ seasonRegistryUniqid, data }) => {
    if (debugStatus.updateBasic) {
      return fakeApiHelper(200, 'success', {
        data: getInitRegistryInfo(),
        error: false,
        message: 'Update registry basic info successfully',
      });
    }

    return ApiService.put(`/api/season_registries/${seasonRegistryUniqid}/basic`, { data });
  },

  updateRegulationFile: ({ seasonRegistryUniqid, file }) => {
    const data = new FormData();
    data.append('pdf', file);
    return ApiService.put(`/api/season_registries/${seasonRegistryUniqid}/regulation_file`, { data });
  },

  updateRequirement: ({ seasonRegistryUniqid, data }) => {
    if (debugStatus.updateRequirement) {
      return fakeApiHelper(200, 'success', {
        data: getInitRegistryInfo(),
        error: false,
        message: 'Update registry requirement info successfully',
      });
    }

    return ApiService.put(`/api/season_registries/${seasonRegistryUniqid}/requirement`, { data });
  },

  uploadDocument: ({ seasonRegistryUniqid, replaceIndex, title, file }) => {
    const data = new FormData();
    data.append('replace_index', replaceIndex);
    data.append('title', title);
    data.append('pdf', file);
    return ApiService.post(`/api/season_registries/${seasonRegistryUniqid}/documents`, { data });
  },

  removeDocument: ({ seasonRegistryUniqid, documentIndex }) => {
    return ApiService.delete(`/api/season_registries/${seasonRegistryUniqid}/documents/${documentIndex}`);
  },

  updateFee: ({ seasonRegistryUniqid, data }) => {
    if (debugStatus.updateFee) {
      return fakeApiHelper(200, 'success', {
        data: getInitRegistryInfo(),
        error: false,
        message: 'Update registry fee info successfully',
      });
    }

    return ApiService.put(`/api/season_registries/${seasonRegistryUniqid}/fee`, { data });
  },

  getReviewTeams: ({ seasonRegistryUniqid, statusList }) => {
    const query = statusList.length === 0 ? '' : '?status=' + statusList.join('&status=');
    return ApiService.get(`/api/season_registries/${seasonRegistryUniqid}/review_teams${query}`);
  },

  updateReviewTeamStatus: ({ seasonRegistryUniqid, reviewTeamUniqid, data }) => {
    return ApiService.put(`/api/season_registries/${seasonRegistryUniqid}/review_teams/${reviewTeamUniqid}/status`, {
      data,
    });
  },

  importReviewTeamToTournament: ({ seasonRegistryUniqid, reviewTeamUniqid }) => {
    return ApiService.post(`/api/season_registries/${seasonRegistryUniqid}/review_teams/${reviewTeamUniqid}/import`);
  },
};

export default SeasonRegistry;
